// Parses text pasted into the global (top-bar) search into a list of search
// terms for the multi-value / bulk search flow.
//
// Delimiters:
//   - commas and newlines are always separators (original behavior).
//   - a SPACE is treated as a separator only when every whitespace-separated
//     token looks like an id (contains at least one digit). This lets users
//     paste a space-separated list of PRO / booking / container numbers, e.g.
//       "5064279 5064281 5064282"
//     while still allowing a multi-word single term such as a driver or
//     customer name ("John Smith") to be pasted and searched as one string
//     rather than being split into "John" and "Smith".
//
// Returns null when the paste is NOT a recognized multi-value list, so the
// caller can let the browser paste normally (single-value paste).
export function parsePastedSearchTerms(pastedText: string): string[] | null {
  const hasCommaOrNewline = /[,\n\r]/.test(pastedText);

  const wsTokens = pastedText.trim().split(/\s+/).filter(Boolean);
  const spaceIsSeparator =
    wsTokens.length > 1 && wsTokens.every((t) => /\d/.test(t));

  if (!hasCommaOrNewline && !spaceIsSeparator) return null;

  // When spaces are separators, split on any whitespace + commas; otherwise
  // keep spaces intact within a term and split only on commas / newlines.
  const splitPattern = spaceIsSeparator ? /[\s,]+/ : /[,\r\n]+/;

  return pastedText
    .split(splitPattern)
    .map((t) => t.trim())
    .filter((t) => t.length > 0);
}
